<div class="text-center fadeIn" *ngIf="isSMSVerification">
  <fa-icon
    [icon]="['fal', 'check-circle']"
    size="6x"
    class="my-5 blue2"
  ></fa-icon>

  <h2 class="mb-4">{{ 'k002519' | translate }}</h2>
  <!-- token: Account confirmed! -->
  <p>{{ 'k002520' | translate }}</p>
  <!-- token: Click on the button to continue with the registration -->
  <button
    type="button"
    class="buttonPortal lg my-4"
    mat-raised-button
    (click)="continueRegister()"
  >
    <span>{{ 'k000226' | translate }}</span>
    <!-- Token: Continuar -->
  </button>
</div>
<div class="text-center fadeIn" *ngIf="!isSMSVerification">
  <fa-icon
    [icon]="['fal', 'check-circle']"
    size="6x"
    class="my-5 blue2"
  ></fa-icon>

  <h2 class="mb-4">{{ 'k002521' | translate }}</h2>
  <!-- token: Confirm your email -->
  <p>
    {{ 'k002522' | translate }}
  </p>
  <!-- token: Thank you very much. Your account has been successfully registered. We have
    sent you an email to confirm and activate your account. -->
</div>
